import React, { useState } from "react";
import CustomFieldModal from "./CustomFieldModal";
import useCustomField from "../../../../../hooks/useCustomField/UseCustomField";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import EditCustomFieldModal from "./EditCustomFieldModal";
import useUpdateCustomField from "../../../../../hooks/useCustomField/useUpdateCustomField";
import useEditCustomField from "../../../../../hooks/useCustomField/useEditCustomField";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import FieldEditModal from "./FieldEditModal/FieldEditModal";

const BasicDetails = ({
  data,
  setData,
  dynamicFields = [],
  hidden,
  require,
  onFieldChange, // Accept onFieldChange prop from parent
  Message,
}) => {
  const [showModal, setShowModal] = useState(false); // State for add field modal
  const [showDeleteModal, setShowDeleteModal] = useState(false); // State for delete confirmation modal
  const [fieldToDelete, setFieldToDelete] = useState(null); // State for the field to delete
  const [division, setDivision] = useState(""); // State for division
  const [message, setMessage] = useState({ type: "", text: "" }); // State for success/error messages

  const { submitCustomField } = useCustomField();
  const { updateCustomField } = useUpdateCustomField();
  const apiUrls = process.env.REACT_APP_API_URLS;

  const {
    showEditModal,
    selectedField,
    handleOpenEditModal,
    handleCloseEditModal,
    handleSubmitUpdateField,
  } = useEditCustomField();

  // Handle form submission for adding a new field
  const handleSubmit = async (data) => {
    const result = await submitCustomField(data);
    if (result.success) {
      toast.success("Field is Added Succefully", {
        position: "top-right",
        autoClose: 600,
      });

      setShowModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 700); // Reload the page on success
    } else {
      toast.error(result.message, {
        position: "top-right",
        autoClose: 1000,
      });
      setShowModal(false);
    }
  };

  // Open Add Field Modal
  const handleOpenModal = () => {
    setDivision("Basic Details");
    setShowModal(true);
  };

  // Open Delete Confirmation Modal
  const handleDeleteField = (field) => {
    setFieldToDelete(field);
    setShowDeleteModal(true);
  };

  // Confirm deletion of the field
  const handleConfirmDelete = async () => {
    if (fieldToDelete) {
      try {
        const response = await axios.delete(
          `${apiUrls}/buyer_settings/custom-fields/${fieldToDelete.id}/`
        );

        if (response.status === 204 || response.status === 200) {
          setMessage({ type: "success", text: "Field deleted successfully!" });
          window.location.reload(); // Reload the page on success
        } else {
          setMessage({ type: "error", text: "Failed to delete the field." });
        }
      } catch (error) {
        setMessage({
          type: "error",
          text: "An error occurred while deleting the field.",
        });
      } finally {
        setShowDeleteModal(false);
        setFieldToDelete(null);
      }
    }
  };

  // Close Delete Confirmation Modal
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setFieldToDelete(null);
  };

  // Handle input changes and notify parent
  const handleInputChange = (e, field) => {
    const { value } = e.target;
    // Update the specific field in the data object
    setData((prevData) => ({
      ...prevData,
      [field.column_name]: value,
    }));
    onFieldChange(field.column_name || field.name, value); // Notify parent of the change
  };

       const [isEditModalOpen, setEditModalOpen] = useState(false)
  const [formData, setFormData] = useState({
    label: '',
    placeholder: '',
    type: 'required',
  });

  const handleSave = () => {
    console.log("Form Data Saved:", formData);
    setEditModalOpen(false);
  };

  return (
    <>
      <div className="border-2 border-gray-200 shadow-lg rounded-md p-6 mt-8">
        <h2 className="text-lg font-semibold mb-4">
          <span className="underline">Basic Details :</span>
        </h2>

        {/* Display success/error messages */}
        {/* {message.text && (
          <div
            className={`p-2 mb-4 rounded-md ${
              message.field_type === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message.text}
          </div>
        )} */}

        {/* Static Fields */}
        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <div className="flex items-center justify-between">
            <label className="block">
              Company ID<span className="text-red-500">*</span>
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Company ID",placeholder:"LBINXXXXXX"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              type="text"
              value={data?.company_id || ""}
              name="company_id" // Add a name for the field
              placeholder="LBINXXXX"
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
              onChange={(e) =>
                handleInputChange(e, { column_name: "company_id" })
              } // Notify parent of changes
              disabled={require}
              readOnly={require}
            />
          </div>

          <div>
            <div className="flex items-center justify-between">
            <label className="block">
              Company Name<span className="text-red-500">*</span>
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Company Name",placeholder:"Enter Company name"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              type="text"
              name="company_name" // Add a name for the field
              value={data?.company_name || ""}
              placeholder="Enter Company name or Web URL"
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
              onChange={(e) =>
                handleInputChange(e, { column_name: "company_name" })
              } // Notify parent of changes
              disabled={require}
              readOnly={require}
            />
          </div>

          {/* Company Website URL */}
          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="companyWebsite" className="block">
              Company Website URL
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Company Website URL",placeholder:"Enter Additional Email ID"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              id="companyWebsite"
              name="companyWebsite"
              type="text"
              placeholder="Enter Additional Email ID"
              className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm"
              value={data?.companyWebsite || ""}
              onChange={(e) =>
                handleInputChange(e, { column_name: "companyWebsite" })
              }
            />
          </div>

          {/* Nature of Business */}
          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="natureOfBusiness" className="block">
              Nature of Business<span className="text-red-500">*</span>
            </label> 
            {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Nature of Business",placeholder:"Select nature of business"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
            <select
              id="natureOfBusiness"
              name="natureOfBusiness"
              className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm"
              value={data?.natureOfBusiness || ""}
              onChange={(e) =>
                handleInputChange(e, { column_name: "natureOfBusiness" })
              }
            >
              <option value="">Select Nature of Business</option>
              {/* Map your options here */}
            </select>
          </div>

          {/* Primary Email ID */}
          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="primaryEmail" className="block">
              Primary Email ID<span className="text-red-500">*</span>
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Primary Email ID",placeholder:"Enter Primary Email ID"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              id="primaryEmail"
              name="primaryEmail"
              type="email"
              placeholder="Enter Primary Email ID"
              className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm"
              value={data?.primaryEmail || ""}
              onChange={(e) =>
                handleInputChange(e, { column_name: "primaryEmail" })
              }
            />
          </div>

          {/* Additional Email ID */}
          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="additionalEmail" className="block">
              Additional Email ID
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Additionam Email ID",placeholder:"Enter Additional email Id"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              id="additionalEmail"
              name="additionalEmail"
              type="email"
              placeholder="Enter Additional Email ID"
              className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm"
              value={data?.additionalEmail || ""}
              onChange={(e) =>
                handleInputChange(e, { column_name: "additionalEmail" })
              }
            />
          </div>

          {/* Primary Contact Number */}
          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="primaryContact" className="block">
              Primary Contact Number<span className="text-red-500">*</span>
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Primary Contact Number",placeholder:"Enter Primary Contact no"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <div className="flex items-center gap-2">
              <span className="px-3 py-2 border-2 border-gray-200 rounded-md bg-gray-100 text-gray-700">
                {/* {selectedDialCode || "+91"} */} +91
              </span>
              <input
                id="primaryContact"
                name="primaryContact"
                type="tel"
                placeholder="Enter Primary Contact No."
                className="flex-1 p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm"
                value={data?.primaryContact || ""}
                onChange={(e) =>
                  handleInputChange(e, { column_name: "primaryContact" })
                }
              />
            </div>
          </div>

          {/* Additional Contact Number */}
          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="additionalContact" className="block">
              Additional Contact Number ( separated by <b>;</b> or <b>,</b> )
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Additional Contact Number",placeholder:"Enter additional contact no"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              id="additionalContact"
              name="additionalContact"
              type="text"
              placeholder="Enter Additional Contact No."
              className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm"
              value={data?.additionalContact || ""}
              onChange={(e) =>
                handleInputChange(e, { column_name: "additionalContact" })
              }
            />
           
          </div>

          {/* Company LinkedIn URL */}
          <div>
            <div className="flex items-center justify-between">
            <label htmlFor="companyLinkedin" className="block">
              Company LinkedIn URL
            </label>
             {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Company LinkedIn URL",placeholder:"Enter company linkedin url"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
            </div>
            <input
              id="companyLinkedin"
              name="companyLinkedin"
              type="text"
              placeholder="Enter Company LinkedIn URL"
              className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm"
              value={data?.companyLinkedin || ""}
              onChange={(e) =>
                handleInputChange(e, { column_name: "companyLinkedin" })
              }
            />
          </div>
        </form>

        {/* Dynamic Fields Rendering */}
        {dynamicFields.length > 0 && (
          <div className="mt-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-3">
              {dynamicFields.map((field, index) => {
                if (!field) return null; // Skip rendering if field is undefined or null
                const columnName = field.column_name || "Unlabeled Field";

                return (
                  field.division === "Basic Details" && (
                    <div key={columnName}>
                      <div className="flex justify-between">
                        <label className="block">
                          {columnName.replace(/_/g, " ")}
                          {field?.is_required && (
                            <span className="text-red-500">*</span>
                          )}
                        </label>

                        <div
                          className={`gap-[5px] ${hidden ? "hidden" : "flex"}`}
                        >
                          <button
                            className="color-[#979797]"
                            onClick={() => handleOpenEditModal(field)}
                          >
                            <MdOutlineEdit className="color-[#979797]" />
                          </button>
                          <button
                            className="color-[#979797]"
                            onClick={() => handleDeleteField(field)}
                          >
                            <MdDeleteOutline className="color-[#979797]" />
                          </button>
                        </div>
                      </div>

                      {/* Render Inputs Based on Type */}
                      {field.field_type === "text" ||
                      field.field_type === "date" ? (
                        <input
                          type={field.field_type}
                          value={data?.[field.column_name] || ""}
                          name={columnName} // Use column_name as the field name
                          placeholder={field.placeholder || ""}
                          className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
                          onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                          disabled={require}
                          readOnly={require}
                        />
                      ) : field.field_type === "radio" ||
                        field.field_type === "checkbox" ? (
                        field.options?.split(",").map((option) => (
                          <div
                            key={option}
                            className="flex items-center space-x-2 mt-1"
                          >
                            <input
                              value={data?.[field.column_name] || { option }}
                              type={field.field_type}
                              id={option}
                              name={columnName} // Use column_name as the field name
                              onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                              disabled={require}
                              readOnly={require}
                            />
                            <label htmlFor={option}>{option}</label>
                          </div>
                        ))
                      ) : field.field_type === "dropdown" ? (
                        <select
                          name={columnName} // Use column_name as the field name
                          className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
                          onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                          disabled={require}
                          readOnly={require}
                        >
                          <option disabled>
                            Select {columnName.replace(/_/g, " ")}
                          </option>
                          {field.options?.split(",").map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      ) : null}
                    </div>
                  )
                );
              })}
            </div>
          </div>
        )}

        {/* Add Field Button */}
         <div className='grid grid-cols-2 items-center px-10 mt-6'>
          <div className='flex items-center justify-end'>
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
          <div className='flex items-center justify-end'>
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
        </div>
      </div>

      <FieldEditModal
        isOpen={isEditModalOpen}
        onClose={() => setEditModalOpen(false)}
        onSave={handleSave}
        formData={formData}
        setFormData={setFormData}
        content={"Basic Details"}
      />

      {/* Add Custom Field Modal */}
      <CustomFieldModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
        division={division}
      />

      {/* Edit Custom Field Modal */}
      <EditCustomFieldModal
        isOpen={showEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleSubmitUpdateField}
        fieldData={selectedField}
      />

      {/* Delete Confirmation Modal */}
      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
      />
      <ToastContainer />
    </>
  );
};

export default BasicDetails;
